import LogsController from 'cio/pods/logs/list/controller';
import { action } from '@ember/object';
import {
  ActivityLogType,
  LogTypeNames,
  LOG_TYPES_FOR_OBJECTS,
  LOG_TYPES_FOR_RELATIONSHIPS_ATTRIBUTES,
} from 'cio/utils/activity-log-types';
import ObjectTypeModel from 'cio/models/object-type';
import ObjectModel from 'cio/models/object';

export default class ObjectActivityController extends LogsController {
  declare objectType: ObjectTypeModel;
  declare model: ObjectModel;

  queryLogs(query: Record<string, any>) {
    return this.model.queryLogs(query);
  }

  hiddenTypes = [
    ...Object.keys(LogTypeNames).filter(
      (key: ActivityLogType) => ![...LOG_TYPES_FOR_OBJECTS, ...LOG_TYPES_FOR_RELATIONSHIPS_ATTRIBUTES].includes(key),
    ),
    ActivityLogType.ObjectDelete,
  ];

  // this is overwriting extendable LogsController value
  get objectTypes() {
    return [this.objectType];
  }

  @action
  onNameChange(name: string) {
    this.name = name;
    this.selected = '';
  }

  @action
  onTypeChange(type: string) {
    this.type = type;
    this.selected = '';
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'object.activity': ObjectActivityController;
  }
}
